import 'whatwg-fetch';
import "regenerator-runtime/runtime";
import Upload from '@keodesign/gcs-browser-upload';
import imageCropTool from './imageCropTool';
import { format_size } from './utils';
import { get_csrf }  from './csrf';
import heic2any from 'heic2any' ;


// polyfill for closest()
if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }
  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
  
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

export default class uploadWidgetPlugin {
    constructor(element) {
        this.element = element;
        this.form = this.element.closest("form");
        this.id = element.id;
        this.upload = null;
        this.mouse_down = false;
        this.mouse_down_coords = null;
        this.mouse_down_position = null;
        this.file_url = document.createElement("a");
        this.image_mode = element.classList.contains('image-upload-tool');
        this.get_upload_url = element.getAttribute('data-get-upload-url');
        this.finalise_url = element.getAttribute('data-finalise-upload-url');
        this.info_url = element.getAttribute('data-get-upload-info');
        this.accept = element.getAttribute('data-accept');
        this.permanent_url = element.getAttribute('data-permanent-url');
        element.insertAdjacentHTML('afterend',
            `<div class='file-upload-container' id='upload-container-${this.id}'>
                <a class="file-browse" id="browse-${this.id}" href="javascript:;" >[Browse...]</a>
                <button id="pause-${this.id}" style="display:none">Pause</button>
                <a class="file-remove" id="remove-${this.id}" href="javascript:;" style="display:none;">[Remove]</a>
                <p class="file-upload-info" style="display:none"></p>
                <progress id="progress-${this.id}" style="display:none"></progress>
            </div>`
        );
        this.wrapper = element.parentElement.querySelector(`#upload-container-${this.id}`);        
        this.browse_input = document.getElementById('browse-' + this.id);        
        this.progress = document.getElementById('progress-' + this.id);
        this.pause_input = document.getElementById('pause-' + this.id);
        this.file_info = this.wrapper.querySelector('.file-upload-info');
        this.remove = document.getElementById('remove-' + this.id);
        this.browse_input.addEventListener('click', this.browse_clicked.bind(this));
        this.pause_input.addEventListener('click', this.pause_clicked.bind(this));
        this.remove.addEventListener('click', this.removeFile.bind(this));

        this.fileSelector = document.createElement('input');
        this.fileSelector.setAttribute('type', 'file');
        this.fileSelector.setAttribute('multiple', 'multiple');

        if (this.accept){
            this.fileSelector.setAttribute('accept', this.accept);
        }
        
        this.fileSelector.addEventListener('change', this.file_selected.bind(this));
        
        
        get_csrf().then((csrf_token) => {        
            this.csrf_token = csrf_token;
            if (this.image_mode) {
                let cropper_width = element.getAttribute('data-width');
                let cropper_height = element.getAttribute('data-height');
                this.imageCropper = new imageCropTool(this.id, this.wrapper, this.element.value, this.csrf_token,
                    this.filechanged.bind(this), this.showLoader.bind(this), this.hideLoader.bind(this), 
                    cropper_width, cropper_height);
            }    
            
            if (!this.csrf_token) {
                alert("Could not get CSRF Token. Cannot crop image.");
            }
            if (this.element.value) {
                this.loadInitialValue();
            } else {
                this.hideLoader();
            }
        });
    }

    /**
     * Method for file validation found here
     */
    validate_file_name_size(file){
        const MAX_FILENAME_LENGTH = 140
        return Boolean(file.name.length <= MAX_FILENAME_LENGTH)
    }

    validate_file_type(file){
        if (this.accept){
            const file_ext = '.' + file.name.split('.').pop().toLowerCase();
            const valid_file_type = this.accept.split(", ");
            
            // skip file type check if there's no valid_file_type set
            if(!valid_file_type){
                return true
            }

            return Boolean(valid_file_type.includes(file_ext));
        }
        return true
    }

    validate_file(file){
        if (!this.validate_file_name_size(file)){
            this.display_upload_error("File name is too long. File name: " + file.name);
            return false;
        }
        if (!this.validate_file_type(file)){
            this.display_upload_error("Invalid file type uploaded");
            return false;
        }
        return true
    }
    
    /**
     * Method for file converstion found here
     */
    async convert_file(file_for_upload){
        const file_ext = '.' + file_for_upload.name.split('.').pop().toLowerCase();
        if (file_ext == '.heic'){
            this.file_info.innerText = 'Converting HEIC to JPG';
            this.progress.style.display = 'none';
            return await this.convert_heic(file_for_upload)
        }
        return file_for_upload
    }

    async convert_heic(file){
        let blobURL = URL.createObjectURL(file);
        let blobRes = await fetch(blobURL);

        // convert response to blob
        let blob = await blobRes.blob();

        // convert to PNG - response is blob
        let conversionResult = await heic2any({
            blob,
            toType:"image/jpeg",
            quality: 1
        });

        var file_name = file.name.substr(0, file.name.lastIndexOf(".")) + ".jpg";
        return new File([conversionResult], file_name);
    }

    /**
     * Method for file upload can be found here
     */

    derive_initial_upload_url(file){
        let upload_url = `${this.get_upload_url}?filename=${encodeURIComponent(file.name)}`;
        upload_url += `&content_type=${encodeURIComponent(file.type)}`;
        upload_url += `&file_size=${encodeURIComponent(file.size)}`;
        return upload_url
    }

    display_upload_start(file){
        this.progress.style.display = 'block';
        this.file_info.innerText = `Uploading ${file.name} (${format_size(file.size)}).`;
        this.file_info.style.display = "block";
        this.progress.max = file.size;
        this.showLoader();
    }

    get_final_upload_url(initial_upload_url, file, callback){
        fetch(initial_upload_url)
        .then((response) => { 
            if (!response.ok) {
                // get error message from body or default to response status
                const error = response.status;
                return Promise.reject(error);
            }
            if (response.redirected && response.url.includes("/login/")) {
                return Promise.reject("Cannot start upload as you are no longer logged in. Please log in again to continue");
            }
            return response.json();
        }).then(async (json) => {
            callback(file, json)
        }).catch(error => {
            if (error == '413'){
    
                this.display_upload_error("The file size is over the allowed limit")
            }
            else{
                this.display_upload_error("Error status code: " + error)
            }
        });
    }

    // This is the main upload function
    async upload_file(file){
        // Set UI to let user now the upload is going to start
        this.display_upload_start(file);
      
        // Validate file first
        if(!this.validate_file(file)){
            return false;
        }
        // Do necessary conversion
        file = await this.convert_file(file)
        
        // Obtain the final upload url, and use that for the file upload
        this.get_final_upload_url(this.derive_initial_upload_url(file), file, this.upload_start.bind(this));
    }

    async upload_start(file, json){
        let upload = new Upload({
            id: this.id,
            url: json.upload_url,
            file: file,
            contentType: file.type,
            onChunkUpload: this.chunkUpload.bind(this)
        });
        try {
            let result = await upload.start();
          
            this.remove.style.display = "block";
            if (this.finalise_url) {//TODO: maybe this could be a callback?
                let form_data = new FormData();
                form_data.append("source_name", result.data.name);
                form_data.append("target_name", file.name);
                if (this.permanent_url){
                    form_data.append("path_prefix", this.get_asset_id() + '/' + this.id);
                }
                
                form_data.append("_csrf_token", this.csrf_token);
                fetch(this.finalise_url, {"method":"POST", body: form_data, credentials: 'same-origin'})
                .then(function(response) {
                    return response.json();
                }).then((response) => {
                    this.upload_completed(file, response.asset_id, response.asset_url);
                });
            } else {
                this.upload_completed(file, 'gcs_temp_file:' + result.data.name);
            }
        } catch (e) {
            this.log('Upload failed! Error:', e);
            this.hideLoader();
        } finally {
            upload = null;
            this.progress.style.display = 'none';
        }
    }

    upload_completed(file, value, url){
        this.element.value = value;
        this.log('File has been uploaded: ' + file.name);
        this.file_info.innerText = `${file.name} uploaded (${format_size(file.size)}).`;

        // Set the href attribute and text content of the link
        this.file_url.href = url;
        this.file_url.textContent = url;
        this.file_url.style.display = "block"

        this.file_info.style.display = "block";
        this.remove.style.display = "block";
        if (this.image_mode) {
            this.imageCropper.setImage(url, value);
        } else {
            this.hideLoader();
        }
    }

    get_asset_id(){
        let currentUrl = window.location.href;
        currentUrl = currentUrl.replace(/\/+$/, '');
        return currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
    }
    /**
     * Method for updating, and adding event to UI found here
     */

    loadInitialValue() {
        this.showLoader();
        fetch(this.info_url.replace('~~asset_id~~', this.element.value),
            {
                credentials: 'same-origin',
                headers:{ 'Accept': 'application/json'}
            }
        )
        .then((response) => {
            if (response.status === 200) {
                return response.json();
            } else {
                throw new Error(response.statusText);
            }
        })
        .then((response) => {
            this.file_info.innerText = `${response.data.original_filename} uploaded (${format_size(response.data.size)}).`;
            this.file_info.style.display = "block";
            
            // Set the href attribute and text content of the link
            this.file_url.href = response.data.asset_url;
            this.file_url.textContent = response.data.asset_url;
            this.file_url.target = "_blank";
            this.file_info.insertAdjacentElement("afterend", this.file_url);
            this.remove.style.display = "block";
            if (this.image_mode) {
                this.imageCropper.setImage(response.data.asset_url, response.data.asset_id);
            } else {
                this.hideLoader();
            }
        }, (error) => {
            this.file_info.innerText = 'Previous file information could not be loaded.';
            this.file_info.style.display = "block";
            this.remove.style.display = "block";
            this.hideLoader();
            this.log("Error loading previous file information " + error);
        });
    }

    browse_clicked() {
        this.fileSelector.click();
    }

    display_upload_error(error){
        this.hideLoader();
        this.progress.style.display = 'none';
        this.file_info.innerText = error;
    }

    file_selected(){
        this.upload_file(this.fileSelector.files[0]);
        this.fileSelector.value = "";
    }

    pause_clicked(){
        if (this.upload) {
            if (this.upload.paused) {
                this.upload.unpause();
            } else {
                this.upload.pause();
            }
          }
    }

    chunkUpload(info){ 
        this.progress.value = info.uploadedBytes;
    }

    removeFile() {
        this.remove.style.display = "none";
        this.file_url.style.display = "none";
        this.element.value = '';
        if (this.image_mode)
            this.imageCropper.removeFile();
        
        this.file_info.innerText = "";
        this.file_info.style.display = "none";        
    }

    showLoader() {
        if (!this.wrapper.querySelector(".loading")) {
            this.wrapper.insertAdjacentHTML('beforeend', '<span class="loading imgcroploader"></span>');
            this.file_upload_disable_form();
        }
    }

    hideLoader() {
        if (this.wrapper.querySelector(".loading")) {
            this.wrapper.querySelector(".loading").remove();
            this.file_upload_enable_form();
        }
    }

    filechanged(newfile) {
        // image cropper has generated a new asset!
        this.element.value = newfile;
    }

    file_upload_disabled_handler(){
        alert('Please wait for uploads to complete before submitting form.');
    }
    
    file_upload_disable_form() {
        //Potentially multiple uploads are locking the form.... We need to know if they are all done. We put our ID in a list.
        if (!this.form.file_upload_disable) {
            this.form.file_upload_disable = [];
            this.form.addEventListener('submit', this.file_upload_disabled_handler);
            Array.from(this.form.querySelectorAll('button, input[type="submit"]')).forEach(el=> {
                el.setAttribute('disabled','disabled');
            });
        }
        this.form.file_upload_disable.push(this.id);
    }

    file_upload_enable_form() {
        //Potentially multiple uploads are locking the form.... We need to only reenable when they are all done.
        var locking_items = this.form.file_upload_disable.filter(value => value != this.id);
        this.form.file_upload_disable = locking_items;
        if (locking_items.length == 0) {
            this.form.file_upload_disable = null;            
            
            this.form.removeEventListener('submit', this.file_upload_disabled_handler);
            
            Array.from(this.form.querySelectorAll('button, input[type="submit"]')).forEach(el=> {
                el.removeAttribute('disabled');
            });
        }
    }

    /**
     * Private Method to log messages
     */
    log(message) {
        if (console && console.log) {
            console.log('[Image-upload] ' + message);
        }
    }
}
